import React, { useState, useMemo, useRef, useEffect } from "react";
import {
  Box,
  Pressable,
  Text,
  VStack,
  FlatList,
  Icon,
  //    Portal,
  Modal,
} from "native-base";
import { Ionicons } from "@expo/vector-icons";

import Input from "../../components/Input";

const SelectWeb = ({
  items,
  placeholder,
  onChange,
  getConfigEmpresa,
  helperText,
  value,
  estiloNovo,
}: {
  items: { label: string; value: string }[];
  placeholder: string;
  onChange: (value: string) => void;
  getConfigEmpresa: any;
  helperText?: string;
  value?: string;
  // Visual do layout novo (só aparência). Sem essa prop fica como antes.
  estiloNovo?: { rotulo?: string; corFoco?: string };
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState<{
    label: string;
    value: string;
    uf?: string;
  } | null>(null);
  const [query, setQuery] = useState("");
  const [naoFiltraAoAbrir, setNaoFiltraAoAbrir] = useState(true);

  const refInput = useRef<any>(null);

  useEffect(() => {
    if (value && items.length > 0) {
      const item = items.find((item) => item.value === value);
      setSelected(item || null);
      setQuery(item?.label || "");
    }
  }, [value, items]);

  const filtered = useMemo(() => {
    if (naoFiltraAoAbrir) {
      return items;
    }

    const q = query.toLowerCase();
    return items.filter((i) => i.label.toLowerCase().includes(q));
  }, [query, items]);

  const handleSelect = (item: any) => {
    setSelected(item);
    setQuery(item.label);
    setIsOpen(false);
    onChange?.(item.value);
  };

  return (
    <Box position="relative" width="100%" overflow="visible" zIndex={10}>
      <Input
        colorItem={getConfigEmpresa.coresPWA.corFonteFiltro}
        corBordaFiltro={getConfigEmpresa.coresPWA.corBordaFiltro}
        value={query || ""}
        styleBox={{ marginTop: estiloNovo ? 0 : 10 }}
        icon={estiloNovo ? undefined : "search"}
        bg={"#fff"}
        estiloNovo={estiloNovo}
        onChangeText={(text) => {
          setNaoFiltraAoAbrir(false);
          setQuery(text);
          setIsOpen(true);
        }}
        width={"100%"}
        ref={refInput}
        onBlur={() => {
          setTimeout(() => {
            setIsOpen(false);
          }, 100);
        }}
        placeholder={placeholder}
        onFocus={() => {
          setIsOpen(true);
          setNaoFiltraAoAbrir(true);
        }}
        InputRightElementProps={
          <Pressable
            onPress={() => {
              setIsOpen((prev) => !prev);
              //seta foco no input
              refInput.current?.focus();
            }}
            mr={2}
          >
            <Icon
              as={Ionicons}
              name={isOpen ? "chevron-up" : "chevron-down"}
              size="sm"
              color="gray.500"
            />
          </Pressable>
        }
        helperText={isOpen ? "" : helperText}
      />

      {/* Dropdown */}
      {isOpen && (
        <VStack
          position="absolute"
          top="100%"
          left={0}
          right={0}
          bg="white"
          borderWidth={1}
          borderColor={estiloNovo ? "rgba(0,0,0,0.08)" : "gray.300"}
          borderRadius={estiloNovo ? 12 : "md"}
          overflow={estiloNovo ? "hidden" : undefined}
          mt={1}
          zIndex={9999}
          maxH={estiloNovo ? 200 : 150}
          shadow={2}
        >
          {filtered.length > 0 ? (
            <FlatList
              data={filtered}
              keyExtractor={(item) => item.value}
              renderItem={({ item }) => (
                <Pressable
                  onPress={() => handleSelect(item)}
                  px={3}
                  py={estiloNovo ? 2.5 : 2}
                  _hover={{ bg: estiloNovo ? "#F7F4EE" : "gray.100" }}
                >
                  <Text>{item.label}</Text>
                </Pressable>
              )}
            />
          ) : (
            <Box px={3} py={2}>
              <Text color="gray.400">Nenhum resultado</Text>
            </Box>
          )}
        </VStack>
      )}
    </Box>
  );
};

export default SelectWeb;
